'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var FaresAverageGridController = function FaresAverageGridController($scope, faresAverageGridService, faresAverageFaresInversionService, BrushSelectionFilter, featureToggleService, $log, $rootScope) {
  $scope.showWarningModal = false;
  $scope.showMappedWarningModal = false;
  $scope.isAverageFaresVisible = function () {
    return $scope.screenState.averageFaresGridState.showAverageFaresGrid;
  };
  $scope.setAverageFaresVisible = function (value) {
    $scope.screenState.averageFaresGridState.showAverageFaresGrid = value;
  };
  function createBrushFilter(filterKeysFromRows) {
    return featureToggleService.isEnabled('SPOS') && filterKeysFromRows.spos ? new BrushSelectionFilter('fbcs-grid', [{
      spos: filterKeysFromRows.spos,
      classes: filterKeysFromRows.classes,
      dateRanges: filterKeysFromRows.dateRanges,
      classSposes: filterKeysFromRows.classSposes
    }]) : new BrushSelectionFilter('fbcs-grid', [{
      classes: filterKeysFromRows.classes,
      dateRanges: filterKeysFromRows.dateRanges
    }]);
  }
  $scope.gridRowSelected = function (rows) {
    var filterKeysFromRows = faresAverageGridService.getFilterKeysFromRows(rows, $scope.showAverageFaresGrid);
    $scope.selectedClasses = filterKeysFromRows.classes;
    return createBrushFilter(filterKeysFromRows);
  };
  $scope.save = function () {
    $scope.showWarningModal = false;
    $scope.showMappedWarningModal = false;
    $scope.validateAndSave($scope.rowsToSave);
  };
  $scope.cancel = function () {
    $scope.showWarningModal = false;
    $scope.showMappedWarningModal = false;
  };
  $scope.saveFares = function (event, rowsToSave) {
    var isAverageFares = $scope.isAverageFaresVisible();
    $scope.rowsToSave = rowsToSave;
    faresAverageFaresInversionService.isFaresInversion(rowsToSave, isAverageFares).then(function (faresInversionExist) {
      if (faresInversionExist) {
        if (isAverageFares) {
          $scope.showWarningModal = true;
        } else {
          $scope.showMappedWarningModal = true;
        }
      } else if (rowsToSave.length > 0) {
        $scope.validateAndSave($scope.rowsToSave);
      }
    });
  };
  $scope.validateAndSave = function (rowsToSave) {
    var isAverageFares = $scope.isAverageFaresVisible();
    if (isSavedDataValid(rowsToSave)) {
      faresAverageGridService.save(rowsToSave, isAverageFares).then(successSavingHandler, errorSavingHandler);
    } else {
      $log.error('FaresAverageGridController: saveFares - Saved value is invalid');
      toastr.error('Saved value is invalid');
    }
  };
  function isSavedDataValid(rowsToSave) {
    var isValid = true;
    rowsToSave.forEach(function (row) {
      if (row.userFare < 0 || row.userMappedFare < 0) {
        isValid = false;
      }
    });
    return isValid;
  }
  function successSavingHandler() {
    $rootScope.$broadcast('clearChangedValue');
    $scope.$broadcast('fares-average-data-grid:saveSuccess');
    toastr.success('Data was saved successfully');
  }
  function errorSavingHandler(error) {
    var message = error.data && error.data.message || error.statusText || error.message;
    $log.error('FaresAverageGridController: errorSavingHandler - ' + message);
    toastr.error(message);
  }
  $scope.$on('cog:gridToolbarFaresAverage', function (event, cogOption) {
    var selectedFlowType = cogOption.val[0];
    if (selectedFlowType === 'MAPPED') {
      $scope.setAverageFaresVisible(false);
    } else if (selectedFlowType === 'REGULAR') {
      $scope.setAverageFaresVisible(true);
    }
    $scope.screenState.averageFaresGridState.selectedFlowType = selectedFlowType;
  });
};
FaresAverageGridController.$inject = ['$scope', 'FaresAverageGridService', 'FaresAverageFaresInversionService', 'BrushSelectionFilterFactory', 'FeatureToggleService', '$log', '$rootScope'];
module.exports = FaresAverageGridController;